/* eslint-disable eqeqeq */
var ezdia;
(function (ezdia) {
    function displayChartElements(charts, obj) {
        var selectedLink = null;
        var context = null;
        var currentBlock = null;
        if (charts.overview) {
            selectedLink = $('#ez-dashboard-charts-nav-wrapper').find('[data-name="overview"]');
            context = charts.overview;
            currentBlock = '#ez-dashboard-charts-overview';
        }
        else {
            selectedLink = $('#ez-dashboard-charts-nav-wrapper').find("[data-name=\"" + obj.link + "\"]");
            context = charts[obj.link];
            currentBlock = "#" + obj.div;
        }
        $(currentBlock).show();
        selectedLink.addClass('active').data('render', true);
        return context;
    }
    function createChartElements(obj, key) {
        var wrapper = $('<div>', {
            id: key,
            css: {
                display: 'none'
            }
        });
        $('#ez-content-health-charts-wrapper').append(wrapper);
    }
    function createChartsWrapper() {
        var config = $.ezdia.config.pageParams;
        var charts = $.data(document, 'ez.dashboard');
        var template = $.ezdia.template.get('content-health-generic-chart-wrapper');
        var suffix = 'ez-dashboard-charts-';
        var firstKey = null;
        var tab = config.tab;
        var wrapper = null;
        $.each(this.options.charts, function each(i, obj) {
            var name = null;
            var key = null;
            var chartId = null;
            key = suffix + obj.name;
            if (!firstKey) {
                firstKey = {
                    link: name,
                    div: key
                };
            }
            if (!charts[name]) {
                createChartElements(obj, key);
            }
            wrapper = $("#" + key);
            chartId = obj.name + config.account + config.role;
            if (!charts[name]) {
                charts[name] = [];
            }
            this.config = this.config || {};
            obj.layout = this.config.layout ? "col-layout-" + this.config.layout : '';
            obj.id = suffix + ezdia.util.sanitizer.specialChar(chartId);
            obj.tab = tab;
            wrapper.append(template(obj));
            charts[name].push(obj);
        });
        $('.ez-expandall-collapseall').show();
        return displayChartElements(charts, firstKey);
    }
    function createEmptyPage() {
        // const template = HtmlTemplates.chartsEmpty;
        // $('#ez-content-health-charts-wrapper').html(template());
    }
    function setBodyHeight() {
        var windowHeight = $(window).height();
        var nav = $('#ez-page-nav-left');
        var navHeight = nav.css('bottom', 'auto').outerHeight();
        var height = 0;
        if (windowHeight > navHeight) {
            height = windowHeight;
        }
        else {
            height = navHeight;
        }
        $('#ez-page-content-wrapper').css('min-height', height);
        nav.css('bottom', 0);
    }
    var contentHealthEmailObjs = {
        options: {
            charts: [],
            pinObj: {},
            pinWrapperId: 'ez-dashboard-pin-msg-wrapper',
            keys: [],
            widgets: {
                date: {},
                group: [],
                select: [],
                tag: []
            }
        },
        load: function () {
            var config = $.ezdia.config.pageParams;
            var queries = ezdia.util.jsonParse(config.queries) || {};
            var self = $.ezdia.dashboard;
            var charts = null;
            $.ezdia.config.pageParams.queries = queries;
            $.data(document, 'ez.dashboard', {});
            setBodyHeight();
            $('#ez-role').basicSearchRole('MyAccount.htm');
            $.ezdia.leftNavToogle();
            if ($.isEmptyObject(this.options.charts)) {
                createEmptyPage();
            }
            else {
                charts = createChartsWrapper.call(this);
                this.renderCharts(charts);
            }
            pageLoadingDone();
            self.onresize();
            $('body').on('click', '[data-type="addProduct"]', function click() {
                ezdia.widgets.contentHealthAnalysis.addProductsDialog(this);
            });
            $('body').on('click', '[data-type="sendForProdOptimization"]', function click() {
                ezdia.widgets.contentHealthAnalysis.sendForProdOptimization(this);
            });
        },
        renderContentHealthPopUp: function (url, obj, targetElement) {
            var self = this;
            $.ajax({
                url: url,
                dataType: 'json',
                success: function (response) {
                    self.repopulateGrid(response, obj);
                    if (targetElement.is('input:text')) {
                        self.repopulateFilter(response);
                    }
                }
            });
        },
        search: function (e) {
            var elem = $(e.currentTarget);
            var formid = elem.data('id');
            var frm = elem.closest("#" + formid);
            var obj = $.data(document, 'ez.contentHealthConfig');
            var url = null;
            if (!obj || elem.hasClass('disabled')) {
                return;
            }
            var formData = $(frm).serializeArray();
            var filterFormData = {};
            // Generating multimap to serialize
            formData.forEach(function (parameter) {
                var existing = filterFormData[parameter.name];
                if (existing) {
                    filterFormData[parameter.name].push(parameter.value);
                }
                else {
                    filterFormData[parameter.name] = [parameter.value];
                }
            });
            var fieldID = frm.find('select')[0].id;
            var brandValues = filterFormData[fieldID];
            filterFormData[fieldID] = [];
            filterFormData[fieldID][0] = brandValues;
            // Adding filter form data
            url = obj.url + "&" + $.param(filterFormData, true);
            $.ezdia.chart.loading("#" + obj.id);
            this.renderContentHealthPopUp(url, obj, elem);
        },
        repopulateGrid: function (resp, obj) {
            var response = resp;
            var dashboardObj = $.ezdia.dashboard;
            var options = $.ezdia.config.pageParams;
            response = response.msg;
            response.id = response.name;
            response.account = response.accountName;
            response.global = false;
            response.config = obj.config;
            response.url = "customHandler.htm?accountName=" + options.account + "&role=" + options.role + "&queryName=" + obj.config.queryName + "&action_handler=" + obj.config.action_handler;
            // update global config
            $.data(document, 'ez.contentHealthConfig', response);
            // update the grid
            dashboardObj.createGrid(response, response);
            var fieldID = $('#content_health_popup_search').find('select')[0].id;
            var selectedBrands = $("#" + fieldID).val();
            if (selectedBrands &&
                selectedBrands.length &&
                ezdia.util.jsonParse(response.response).length) {
                $('.ez-brand-selection').removeAttr('disabled');
            }
            else {
                $('.ez-brand-selection').attr('disabled', 'disabled');
            }
            var validator = $('#ez-form-send-email').validate();
            validator.resetForm();
        },
        repopulateFilter: function (resp) {
            var response = resp.msg;
            var template = $.ezdia.template.get('content-health-filter');
            var newFilterData = response.queryFieldsJson[1];
            response.queryFieldsJson = [];
            response.queryFieldsJson.push(newFilterData);
            newFilterData.formName = response.name;
            template = template(newFilterData);
            // populate the filter
            $("#" + response.queryFieldsJson[0].name + "_container")
                .empty()
                .append(template);
            response.queryFieldsJson.forEach(function (element) {
                element.edittype = element.type;
                element.editable = true;
                $("[name=" + element.name + "]").change(function (e) {
                    $.ezdia.contentHealthEmailObj.search(e);
                });
            });
            // bind event
            $.ezdia.widgets.renderAll(response.queryFieldsJson);
            $('.ez-brand-selection').attr('disabled', 'disabled');
        },
        renderCharts: function (charts) {
            var self = this;
            if (!charts) {
                return;
            }
            $.each(charts, function (i, obj) {
                self.ajaxCall(obj.url, obj);
            });
        },
        ajaxCall: function (url, obj) {
            var self = $.ezdia.dashboard;
            $.ajax({
                url: url,
                dataType: 'json',
                success: function (resp) {
                    var response = resp.dashboard[0];
                    switch (obj.type) {
                        case 'grid':
                        case 'summary':
                        case 'analytics':
                            self.createGrid(response, obj);
                            if (obj.config.optimise) {
                                self.addCustomButton("#" + obj.id, obj.config);
                            }
                            break;
                        case 'html':
                        case 'url':
                            if (
                            // tslint:disable-next-line: triple-equals
                            response.response != '{}' &&
                                // tslint:disable-next-line: triple-equals
                                response.response != '[]' &&
                                response.response) {
                                self.htmlCard(response, obj);
                                response.config = response.config
                                    ? ezdia.util.jsonParse(response.config)
                                    : '';
                                if (response.config.parent) {
                                    if ($("#ez-dashboard-charts-" + response.config.parent).length) {
                                        $("#ez-dashboard-charts-" + obj.name)
                                            .find('.ez-grp-heading-grid')
                                            .html(response.title);
                                    }
                                    else {
                                        $("#ez-dashboard-charts-" + obj.name).remove();
                                    }
                                }
                                if (response.config.isSendForOptimsation) {
                                    $('.send-for-optimisation').show();
                                }
                            }
                            else {
                                var config_1 = response.config
                                    ? ezdia.util.jsonParse(response.config)
                                    : '';
                                $("#ez-dashboard-charts-" + obj.name).remove();
                                if (config_1.isSendForOptimsation) {
                                    $('.send-for-optimisation').hide();
                                }
                            }
                            break;
                        case 'stackedchart':
                            if (response.xAxis.length && response.yAxis.length) {
                                $.ezdia.chart.create(response, obj);
                            }
                            else {
                                $("#ez-dashboard-charts-" + obj.name).remove();
                            }
                            break;
                        default:
                            if (response.response != '[]' &&
                                response.response != '{}' &&
                                response.response) {
                                $.ezdia.chart.create(response, obj);
                            }
                            else {
                                response.config = response.config
                                    ? ezdia.util.jsonParse(response.config)
                                    : '';
                                if (response.config.dependent) {
                                    $("#ez-dashboard-charts-" + obj.name).parent().remove();
                                }
                                else {
                                    $("#ez-dashboard-charts-" + obj.name).remove();
                                }
                            }
                            break;
                    }
                    $('.reporting-chart-wrapper:not(:has(.ez-dashboard-charts))').remove();
                },
                error: function (response) {
                    switch (obj.type) {
                        case 'grid':
                        case 'summary':
                        case 'analytics':
                            self.createGrid(response, obj);
                            break;
                        case 'rss':
                            $.ezdia.rss(response, obj);
                            break;
                        case 'task':
                            self.taskList(response, obj);
                            break;
                        case 'html':
                        case 'url':
                            self.htmlCard(response, obj);
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
    var pages;
    (function (pages) {
        pages.contentHealthEmailObj = contentHealthEmailObjs;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.contentHealthEmailObj = contentHealthEmailObjs;
})(ezdia || (ezdia = {}));
